import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from '../../core/network/api';
import { farmKeys, farmPaths } from '../queries/farms';

// TSS vite/03 — read compartido de las fincas del cliente. Vive en common/
// (no en una feature) porque lo consumen fincas + receptoras + donadoras
// (FarmSelect). Las MUTACIONES de finca NO viven aquí: son de la feature
// `fincas` (features/fincas/contexts/farm-mutations.jsx).
//
// GET public/farms es una lectura COMPUESTA → viene ENVUELTA en el sobre
// público (0052): { schema_version, view:"farms", data:{items,pagination},
// available_modules }. El caller lee items/pagination con envelopeData()
// (core/network/envelope.js) — nunca de la raíz.
//
// El owner_id (scope) lo fuerza el token server-side; jamás se envía desde acá.
export function useClientFarms({ limit, offset, q } = {}) {
    return useQuery({
        queryKey: farmKeys.list({ limit, offset, q }),
        queryFn: ({ signal }) =>
            api.get(farmPaths.list(), { params: { limit, offset, q }, signal }).then((r) => r.data),
        // Mantiene la página actual en pantalla mientras carga la siguiente.
        placeholderData: keepPreviousData,
    });
}
